import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'

const state = {
  strolls: [],
  categories: [],
  activeCategories: [],
  activeCheckpoint: null,
  activeStroll: null,
}

export {
  state,
  actions,
  mutations,
  getters
}
